import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { t } from "i18next";
import { useState } from "react";
import { Select } from "../../components/Select/Select.component";
import { Icon } from "../Icon";
export function ActionSelect({
  id,
  date,
  selectAction,
  start,
  end
}: {
  id: number
  date: Date
  selectAction: (
    action: string, 
    date: Date, 
    slotId: number,
    start: string,
    end: string
  ) => void
  start: string
  end: string
}) {

  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <Stack 
      aria-hidden={ isOpen ? undefined : "true" }
      direction={ "row" }
      sx={ {
        "& svg.icon": {
          cursor: "pointer"
        }
      } }
    >
      <Select
        options={ [
          {
            children: "Modifica",
            value: "modify"
          },
          {
            children: "Elimina",
            value: "remove"
          }
        ] }
        open={ isOpen }
        onClose={ () => setIsOpen(false) }
        onOpen={ () => setIsOpen(true) }
        onChange={ (changeEvent) => {
          selectAction(
            changeEvent.target.value as string,
            date,
            id,
            start,
            end
          );
        } }
        value={ "" }
        className="action-select"
        tabIndex={ isOpen ? 0 : -1 } 
        aria-hidden={ isOpen ? undefined : "true" }  
        sx={ {
          height: "0px",
          zIndex: "-1",
          display: isOpen ? "block" : "none" 
        } }
        MenuProps={ {
          className:"action-menu",
          sx: {
            "& .MuiPaper-root": {
              translate: "-48px -2px"
            }
          }
        } }
      />
      <Icon
        tabIndex={ 0 }
        aria-label={ t("modify_delete") }
        icon={ "Icons_impostazioni" }
        size={ "17px" }
        color={ theme.customColors.systemPrimary01 }
        onClick={ ()=> setIsOpen(true) }
        onKeyDown={ (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen(true);  
          } }
        }
      />
    </Stack>
  );
}

